import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap"
import {changeProductionStatusV3} from "../../../services/api/apiNextBarcode"
import {pushNewItemHistory} from "../../../services/api/apiItemHistory"
import className from "classnames";

class ModalEditStatus extends Component {
    state = {
        status: '',
        customerChange: '',
        note: '',
        loading: false,
        validated: false
    }

    _handleChange = e => {
        const {name, value} = e.target

        this.setState({
            [name]: value
        })
    }

    _handleClickChange = e => {
        e.preventDefault()

        return this._change()
    }

    _change = async () => {
        this.setState({
            validated: true
        })

        if (this.state.loading || this.state.customerChange === '' || this.state.note === '') return false

        if (window.confirm("Bạn có chắc chắn muốn thay đổi trạng thái?")) {
            this.setState({loading: true})

            const {status, customerChange, note} = this.state
            try {
                const {_id, production_status} = this.props.item

                const response = await changeProductionStatusV3(_id, status)

                const {success, message} = response

                if (!success) {
                    return this.setState({
                        loading: false
                    }, () => {
                        window.alert(message)
                    })
                }

                this.setState({
                    loading: false
                }, () => {
                    this.props.onClose()
                    this.props.reloadItems()
                    return pushNewItemHistory(`${this.props.item.barcodeNumber}_1`, {
                        event_key: 'change_status',
                        event_description: `Change status on single action`,
                        user_created: customerChange,
                        note: note,
                        event_meta: {
                            from: production_status,
                            to: status
                        }
                    })
                })
            } catch (e) {
                this.setState({
                    loading: false
                }, () => {
                    window.alert(e.message)
                })
            }
        }
    }

    render() {
        const {isOpen, onClose, roles} = this.props
        const {status, loading, customerChange, note, validated} = this.state

        return (
            <div className="ModalEditStatus">
                <Modal isOpen={isOpen} toggle={onClose}>
                    <ModalHeader toggle={onClose}>Cập nhật trạng thái</ModalHeader>
                    <ModalBody>
                        <div className="selectStatus mb-3 row">
                            <label className="col-sm-3 col-form-label">Trạng thái </label>
                            <div className="col-sm-9">
                                {
                                    roles.indexOf('fac_ffm') >= 0 || roles.indexOf('fac_admin') >= 0 ? <select className="form-control" name="status" value={status} onChange={this._handleChange}>
                                        <option value="">Chọn trạng thái</option>
                                        <option value="pending">Pending</option>
                                        <option value="on-hold">On Hold</option>
                                        <option value="cancelled">Cancel</option>
                                        <option value="cancel-ship">Cancel ship</option>
                                        <option value="manual-package">Manual packaged</option>
                                    </select> : <select className="form-control" name="status" value={status} onChange={this._handleChange}>
                                        <option value="">Chọn trạng thái</option>
                                        <option value="pending">Pending</option>
                                        <option value="on-hold">On Hold</option>
                                        <option value="manual-package">Manual packaged</option>
                                    </select>
                                }
                            </div>
                        </div>
                        {(status !== '') && (
                            <div>
                                <div className="customerChange mb-3 row">
                                    <label className="col-sm-3 col-form-label">Người thực hiện</label>
                                    <div className="col-sm-9">
                                        <input className={className('form-control', (customerChange === '' && validated) && 'border-danger')} name="customerChange" onChange={this._handleChange}/>
                                        {(customerChange === '' && validated) && (
                                            <div className="text-danger mt-1">Vui lòng nhập người thực hiện </div>
                                        )}
                                    </div>
                                </div>
                                <div className="customerChange mb-3 row">
                                    <label className="col-sm-3 col-form-label">Lý do</label>
                                    <div className="col-sm-9">
                                        <input className={className('form-control', (note === '' && validated) && 'border-danger')} name="note" onChange={this._handleChange}/>
                                        {(note === '' && validated) && (
                                            <div className="text-danger mt-1">Vui lòng nhập lý do </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter className="d-flex justify-content-between">
                        <button className="btn btn-secondary" color="secondary" onClick={onClose}>Hủy</button>
                        <button disabled={loading || !status} onClick={this._handleClickChange} className="btn btn-primary">
                            Cập nhật trạng thái
                        </button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

ModalEditStatus.propTypes = {
    reloadItems: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
}

export default ModalEditStatus
